"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _mobileDialog = _interopRequireDefault(require("./mobileDialog"));
var _SNETDialogModule = _interopRequireDefault(require("./SNETDialog.module.css"));
var _material = require("@mui/material");
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SnetDialog = _ref => {
  let {
    isDialogOpen,
    isHeaderHidden,
    title,
    children,
    disableBackdropClick,
    disableEscapeKeyDown,
    contentClass,
    titleClass,
    onDialogClose,
    showCloseButton = true,
    ...props
  } = _ref;
  const isMobile = window.screen.width <= 550; //px

  // eslint-disable-next-line no-unused-vars
  const handleDialogClose = (event, reason) => {
    if (disableBackdropClick && reason === "backdropClick") {
      return false;
    }
    if (disableEscapeKeyDown && reason === "escapeKeyDown") {
      return false;
    }
    onDialogClose?.();
  };
  if (isMobile) {
    return /*#__PURE__*/_react.default.createElement(_mobileDialog.default, {
      isDialogOpen: isDialogOpen,
      onDialogClose: onDialogClose,
      title: title,
      children: children
    });
  }
  return /*#__PURE__*/_react.default.createElement(_material.Dialog, _extends({
    "max-width": "xl",
    onClose: (event, reason) => handleDialogClose(event, reason),
    "aria-labelledby": "snet-dialog-title",
    open: isDialogOpen,
    PaperProps: props?.PaperProps,
    disableScrollLock: true
  }, props), !isHeaderHidden && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: (0, _clsx.default)(_SNETDialogModule.default.dialogTitle, titleClass)
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: _SNETDialogModule.default.titleText
  }, title), showCloseButton && onDialogClose && /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-label": "close",
    onClick: onDialogClose,
    className: _SNETDialogModule.default.iconButton
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null))), /*#__PURE__*/_react.default.createElement(_material.DialogContent, {
    dividers: true,
    className: `${_SNETDialogModule.default.dailogContent}, ${contentClass}`
  }, children));
};
SnetDialog.propTypes = {
  isDialogOpen: _propTypes.default.bool.isRequired,
  isHeaderHidden: _propTypes.default.bool,
  onDialogClose: _propTypes.default.func,
  title: _propTypes.default.string,
  children: _propTypes.default.node,
  showCloseButton: _propTypes.default.bool,
  disableBackdropClick: _propTypes.default.bool,
  disableEscapeKeyDown: _propTypes.default.bool,
  contentClass: _propTypes.default.string,
  props: _propTypes.default.shape({
    PaperProps: _propTypes.default.object
  })
};
var _default = exports.default = SnetDialog;